import {
  Box,
  Button,
  Flex,
  H4,
  ModalContainer,
} from '@ouster/webviz-react-components';

import { MdNotificationImportant } from 'react-icons/md';

export interface HandoverModalProps {
  isOpen: boolean;
  title?: string;
  handleClose: () => void;
  handleHandoverConfirm: () => Promise<void>;
}

export default function HandoverModal({
  isOpen,
  handleClose,
  handleHandoverConfirm,
  title = 'Organization Ready',
}: HandoverModalProps) {
  const content = (
    <Box width="40rem">
      <Box as="p" color="gray.200" lineHeight="tall">
        Your environment is set up and your recordings are pre-loaded. By
        proceeding, you accept full administrative ownership of this
        organization.
      </Box>

      <Flex
        align="start"
        gap={4}
        p={4}
        border="1px solid"
        borderColor="yellow.400"
        borderRadius="md"
        mt={6}
        bgColor="yellow.900"
      >
        <MdNotificationImportant fontSize={64} color="yellow.300" />
        <Box>
          <H4
            color="yellow.300"
            mb={2}
            textTransform="uppercase"
            letterSpacing="wider"
          >
            Security Notice
          </H4>
          <Box as="p" color="gray.100" lineHeight="tall" fontSize={14}>
            Ouster’s temporary setup access will be revoked now. If you need
            ongoing support, please manually re-invite your{' '}
            <Box as="span" fontWeight="semibold">
              field application engineers
            </Box>{' '}
            once you’ve gained access.
          </Box>
        </Box>
      </Flex>

      <Flex justifyContent="flex-end" mt={8}>
        <Button onClick={handleHandoverConfirm}>Confirm & Get Started</Button>
      </Flex>
    </Box>
  );

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={handleClose}
      header={title}
      content={content}
      footer={null}
      closeable={false}
      autoFocus={false}
    />
  );
}
